// 推荐人工具函数
export interface ReferralInfo {
    referrerId: string
    channelId: string
}

const REFERRAL_KEY = "referral-info"

// 解析 URL 中的 r 参数（base64），返回 { referrerId, channelId }
export function getReferralFromUrl(): ReferralInfo | null {
    if (typeof window === "undefined") return null
    const params = new URLSearchParams(window.location.search)
    const encoded = params.get("r")
    if (!encoded) return null
    try {
        const decoded = atob(encoded)
        // 兼容 r=推荐人ID,渠道ID 或 推荐人ID,渠道ID
        const match = decoded.match(/^(?:r=)?(\d+),(\d+)$/)
        if (!match) return null
        const info = { referrerId: match[1], channelId: match[2] }
        setReferralToStorage(info.referrerId, info.channelId)
        return info
    } catch (e) {
        // base64 解码失败
        // console.warn("Failed to decode referral from url", e)
        return null
    }
}

// 存储推荐人信息到 localStorage
export function setReferralToStorage(referrerId: string, channelId: string) {
    if (typeof window === "undefined") return
    try {
        const value = JSON.stringify({ referrerId, channelId })
        localStorage.setItem(REFERRAL_KEY, value)
    } catch (e) {
        // localStorage 失败
        // console.warn("Failed to save referral to storage", e)
    }
}

// 从 localStorage 获取推荐人信息
export function getReferralFromStorage(): ReferralInfo | null {
    if (typeof window === "undefined") return null
    try {
        const value = localStorage.getItem(REFERRAL_KEY)
        if (!value) return null
        const obj = JSON.parse(value)
        if (typeof obj.referrerId === "string" && typeof obj.channelId === "string") {
            return obj
        }
        return null
    } catch (e) {
        // localStorage 失败
        // console.warn("Failed to get referral from storage", e)
        return null
    }
}

// 获取推荐人信息，优先 URL，再 localStorage
export function getReferral(): ReferralInfo | null {
    return getReferralFromUrl() || getReferralFromStorage()
}

// 注册请求时自动加上 re-id、ch-id
export function setReferralHeaders(headers: Record<string, unknown>): Record<string, unknown> {
    const referral = getReferral()
    if (referral) {
        return {
            ...headers,
            "re-id": referral.referrerId,
            "ch-id": referral.channelId,
        }
    }
    return { ...headers }
}

// 生成推荐链接
export function buildReferralUrl(
    env: "dev" | "fat" | "uat" | "prod",
    referrerId: string,
    channelId: string,
): string {
    const raw = `r=${referrerId},${channelId}`
    const encoded = btoa(raw)
    const envMap = {
        dev: "https://client-beta.filbet2025.com",
        fat: "https://client-fat.filbet2025.com",
        uat: "https://client-beta.filbet.zone",
        prod: "https://filbet.com",
    }
    const baseUrl = envMap[env]
    return `${baseUrl}?r=${encoded}`
}
